// Copyright (c) 2023 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {putDuplicatePinPlate} from '../../shared/repositories';

import {readDuplicatePinPlate} from './get-duplicate-pin-plate';
import {successAlertBar} from '../../../shared/services/alert-bar';

export const updateDuplicatePinPlateStatus = (duplicatePinPlate, selectedAccount) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await putDuplicatePinPlate(duplicatePinPlate);

            successAlertBar('DUPLICATE_PIN_PLATE_REQUEST_UPDATED');

            readDuplicatePinPlate(selectedAccount)(dispatch);

        } catch (error) {
        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/put-duplicate-pin-plate.js